import React, {
  useState,
  useMemo,
  useCallback,
  useEffect,
  useRef,
} from 'react';
import { toast } from 'react-toastify';

import { isValid, parseISO, format } from 'date-fns';
import { isArray, assign } from 'lodash';
import qs from 'querystring';

import { Modal } from '~/components';
import { DESCARGA_NF, SOBRAS_E_FALTAS } from '~/constants/modules';
import { t, can } from '~/helpers';
import api from '~/services/api';

import * as S from './styles';
import Tabela from './Tabela';

const defaultDadosAPI = {
  idposto: -1,
  idtanquevirtual: -1,
  idproduto: -1,
};

function ArqueacaoTanque() {
  const [post, setPost] = useState([]);
  const [virtual, setVirtual] = useState([]);
  const [produto, setProduto] = useState([]);
  const [fisico, setFisico] = useState([]);
  const [dadosAPI, setDadosAPI] = useState(defaultDadosAPI);
  const [tanqueFisicoEmArq, setTanqueFisicoEmArq] = useState(-1);
  const [tanqueAArquear, setTanqueAArquear] = useState(-1);
  const [loading, setLoading] = useState(false);
  const [loadingStartArqueacao, setLoadingStartArqueacao] = useState(false);
  const [loadingEndArqueacao, setLoadingEndArqueacao] = useState(false);

  const alertaStartArqueacaoRef = useRef(null);
  const confirmStartArqueacaoRef = useRef(null);
  const confirmEndArqueacaoRef = useRef(null);

  // const profile = useSelector((state) => state.user.profile);

  // Cabeçalho postos
  const cellPost = useMemo(
    () => [
      {
        id: 'nomeposto',
        label: t('s.configuracao.arqueacao.idposto'),
      },
    ],
    []
  );

  // Cabeçalho tanque virtual
  const cellVirtualTank = useMemo(
    () => [
      {
        id: 'idtanquevirtual',
        label: t('s.configuracao.tanquefisico.idtanquevirtual'),
      },
      {
        id: 'nomeproduto',
        label: t('s.cadastro.empresaveiculo.nomeproduto'),
      },
    ],
    []
  );

  // Cabeçalho produtos
  const cellProduto = useMemo(
    () => [
      {
        id: 'nomeproduto',
        label: t('s.cadastro.empresaveiculo.nomeproduto'),
      },
    ],
    []
  );

  // Cabeçalho tanque físico
  const cellPhysicalTank = useMemo(
    () => [
      {
        id: 'codigotanquefisico',
        label: t('s.configuracao.tanquefisico.codigotanquefisico'),
      },
      {
        id: 'datahorainiciohistoricoarqaut',
        label: t('s.configarqaut.datahorainiciohistoricoarqaut'),
      },
      {
        id: 'datafinalultimohistoricoarqaut',
        label: t('Fim Última Arqueação'),
      },
    ],
    []
  );

  // Buscar todos os postos na API.
  const handleResponseAPIPost = useCallback(async () => {
    try {
      const { data } = await api.get('postos/postosarqautliberada');

      setPost(data);
    } catch (err) {
      if (isArray(err)) err.map((e) => toast.error(t(e)));
      else toast.error(t(err));
    }
  }, []);

  // Busca tanques virtuais na API.
  const handleResponseAPIVirtual = useCallback(async (id) => {
    const params = {
      wherefield: ['idposto', 'statustanquevirtual'],
      valuewherefield: [id, 'L'],
      typewherefield: ['EQUALS', 'EQUALS'],
    };

    try {
      const { data } = await api.get('tanquesvirtuais', {
        params,
        paramsSerializer: (param) => qs.stringify(param),
      });

      setVirtual(data.items);
    } catch (err) {
      if (isArray(err)) err.map((e) => toast.error(t(e)));
      else toast.error(t(err));
    }
  }, []);

  // Busca produtos na API.
  const handleResponseProduto = useCallback(async (id) => {
    try {
      const { data } = await api.get(`produtos/produtosposto/${id}`);

      setProduto(data);
    } catch (err) {
      if (isArray(err)) err.map((e) => toast.error(t(e)));
      else toast.error(t(err));
    }
  }, []);

  // Busca de tanque físico na API.
  const handleResponseAPIFisico = useCallback(
    async (id, nomeIdPesquisa, idPesquisa) => {
      const params = {
        wherefield: [
          'idposto',
          'statustanquefisico',
          nomeIdPesquisa,
          'tiposondatanquefisico',
        ],
        valuewherefield: [id, 'L', idPesquisa, 0],
        typewherefield: ['EQUALS', 'EQUALS', 'EQUALS', 'NEQUALS'],
      };

      try {
        const { data } = await api.get('arqueacaotanque', {
          params,
          paramsSerializer: (param) => qs.stringify(param),
        });

        if (!data || !Array.isArray(data.items)) {
          toast.error('Resposta inválida da API:', data);
          return;
        }

        const tanquesFisicos = [];
        for (let i = 0; i < data.items.length; i += 1) {
          const dados = data.items[i];

          const tq = {
            idtanquefisico: dados.idtanquefisico,
            codigotanquefisico: dados.codigotanquefisico,
            datahorainiciohistoricoarqaut: '',
            datafinalultimohistoricoarqaut: '',
            datahorafimhistoricoarqaut: '',
          };

          // Verifica se possui uma arqueação válida, seja finalizada ou em
          // andamento.
          if (
            dados.idhistoricoarqaut &&
            dados.idhistoricoarqaut > 0 &&
            dados.arqautcanceladahistoricoarqaut === 0
          ) {
            // Verifica se possui data de início.
            const dataIniObj = parseISO(dados.datahorainiciohistoricoarqaut);

            if (isValid(dataIniObj)) {
              tq.datahorainiciohistoricoarqaut = format(
                dataIniObj,
                'dd/MM/yyyy HH:mm:ss'
              );
            }

            if (dados.datahorafimhistoricoarqaut !== null) {
              const dataFimObj = parseISO(dados.datahorafimhistoricoarqaut);

              if (isValid(dataFimObj)) {
                setTanqueFisicoEmArq(-1);
              } else {
                setTanqueFisicoEmArq(dados.idtanquefisico);
              }
            } else {
              setTanqueFisicoEmArq(dados.idtanquefisico);
            }
          } else {
            setTanqueFisicoEmArq(-1);
          }

          const dataFimObj = parseISO(dados.datafinalultimohistoricoarqaut);

          if (isValid(dataFimObj)) {
            tq.datafinalultimohistoricoarqaut = format(
              dataFimObj,
              'dd/MM/yyyy HH:mm:ss'
            );
          }
          tanquesFisicos.push(tq);
        }

        setFisico(tanquesFisicos);
      } catch (err) {
        if (isArray(err)) err.map((e) => toast.error(t(e)));
        else toast.error(t(err));
      }
    },
    []
  );

  // Callback posto
  const handleCallbackPosto = useCallback(
    (value) => {
      const { idposto } = value;

      if (idposto !== dadosAPI.idposto) {
        if (can(DESCARGA_NF) || can(SOBRAS_E_FALTAS)) {
          handleResponseAPIVirtual(idposto);
        } else {
          handleResponseProduto(idposto);
        }

        setVirtual([]);
        setFisico([]);
        setProduto([]);
        setDadosAPI({ ...defaultDadosAPI, idposto });
      }
    },
    [handleResponseAPIVirtual, handleResponseProduto]
  );

  // Callback tanque virtual
  const handleCallbackVirtual = useCallback(
    (value) => {
      const { idposto, idtanquevirtual, idproduto } = value;

      setFisico([]);
      handleResponseAPIFisico(idposto, 'idtanquevirtual', idtanquevirtual);
      setDadosAPI({ ...dadosAPI, idtanquevirtual, idproduto });
    },
    [handleResponseAPIFisico, dadosAPI]
  );

  // Callback produto
  const handleCallbackProduto = useCallback(
    (value) => {
      const { idproduto } = value;

      setFisico([]);
      handleResponseAPIFisico(dadosAPI.idposto, 'idproduto', idproduto);

      setDadosAPI({
        ...dadosAPI,
        idproduto,
      });
    },
    [dadosAPI.idposto, handleResponseAPIFisico, dadosAPI]
  );

  // Submit form
  const handleSubmit = useCallback(
    async (value) => {
      if (tanqueFisicoEmArq === value) {
        return;
      }

      setLoading(true);

      if (value == -1) {
        setLoadingEndArqueacao(false);
        confirmEndArqueacaoRef.current.handleOpenModal({ data: {} });
      } else {
        setLoadingStartArqueacao(false);
        setTanqueAArquear(value);
        alertaStartArqueacaoRef.current.handleOpenModal({ data: {} });
      }

      setLoading(false);
    },
    [dadosAPI, tanqueFisicoEmArq]
  );

  const handleConfirmStartArqueacao = useCallback(() => {
    setLoading(true);
    alertaStartArqueacaoRef.current.handleCloseModal();
    confirmStartArqueacaoRef.current.handleOpenModal({ data: {} });
    setLoading(false);
  });

  const handleStartArqueacao = useCallback(async () => {
    setLoadingStartArqueacao(true);

    try {
      await api.put(
        `arqueacaotanque/atualiza/${dadosAPI.idposto}/${tanqueAArquear}`
      );

      if (can(DESCARGA_NF) || can(SOBRAS_E_FALTAS)) {
        await handleResponseAPIFisico(
          dadosAPI.idposto,
          'idtanquevirtual',
          dadosAPI.idtanquevirtual
        );
      } else {
        await handleResponseAPIFisico(
          dadosAPI.idposto,
          'idproduto',
          dadosAPI.idproduto
        );
      }

      confirmStartArqueacaoRef.current.handleCloseModal();

      toast.success(t('s.operacao.arqueacaotanque.iniciousucesso'));
    } catch (err) {
      if (isArray(err)) err.map((e) => toast.error(t(e)));
      else toast.error(t(err));

      setLoadingStartArqueacao(false);
    }
  }, [dadosAPI, tanqueAArquear]);

  const handleEndArqueacao = useCallback(async () => {
    try {
      setLoadingEndArqueacao(true);

      await api.put(
        `arqueacaotanque/finaliza/${dadosAPI.idposto}/${tanqueFisicoEmArq}`
      );

      if (can(DESCARGA_NF) || can(SOBRAS_E_FALTAS)) {
        await handleResponseAPIFisico(
          dadosAPI.idposto,
          'idtanquevirtual',
          dadosAPI.idtanquevirtual
        );
      } else {
        await handleResponseAPIFisico(
          dadosAPI.idposto,
          'idproduto',
          dadosAPI.idproduto
        );
      }

      confirmEndArqueacaoRef.current.handleCloseModal();

      toast.success(t('s.operacao.arqueacaoautomatica.finalizada'));
    } catch (err) {
      if (isArray(err)) err.map((e) => toast.error(t(e)));
      else toast.error(t(err));
      setLoadingEndArqueacao(false);
    }
  }, [dadosAPI, tanqueFisicoEmArq]);

  // Start application
  useEffect(() => {
    handleResponseAPIPost();
  }, []);

  return (
    <S.Wrapper>
      <S.WrapperTable>
        <Tabela
          title={t('s.configuracao.arqueacao.idposto')}
          cells={cellPost}
          data={post}
          size="small"
          height="75vh"
          clickOnCell={handleCallbackPosto}
        />

        {(can(DESCARGA_NF) || can(SOBRAS_E_FALTAS)) && (
          <Tabela
            title={t('s.menu.cadastro.tanquevirtual.tanquevirtual')}
            cells={cellVirtualTank}
            data={virtual}
            size="small"
            height="75vh"
            clickOnCell={handleCallbackVirtual}
          />
        )}

        {!can(DESCARGA_NF) && !can(SOBRAS_E_FALTAS) && (
          <Tabela
            title={t('s.menu.configuracao.produto')}
            cells={cellProduto}
            data={produto}
            size="small"
            height="75vh"
            clickOnCell={handleCallbackProduto}
          />
        )}

        <Tabela
          checkbox
          title={t('s.menu.configuracao.tanquefisico')}
          cells={cellPhysicalTank}
          data={fisico}
          size="small"
          height="75vh"
          handleSubmit={handleSubmit}
          unique="idtanquefisico"
          loading={false}
          defaultChecked={tanqueFisicoEmArq}
          atualizandoArq={loading}
        />
      </S.WrapperTable>

      <Modal
        ref={alertaStartArqueacaoRef}
        disableBackdropClick
        disableEscapeKeyDown
        component={() => <p>{t('s.operacao.textoalertainiciararqueacao')}</p>}
        title={t('s.operacao.arqueacaoautomatica.iniciar')}
        maxWidth="xs"
        loading={loading}
        actions={[
          {
            label: t('s.geral.iniciar'),
            disabled: loading,
            autoFocus: true,
            variant: 'outlined',
            color: 'primary',
            callback: (data) => handleConfirmStartArqueacao(),
          },
          {
            label: t('s.geral.botaovoltar'),
            disabled: loading,
            variant: 'outlined',
            color: 'secondary',
            callback: () => alertaStartArqueacaoRef.current.handleCloseModal(),
          },
        ]}
      />

      <Modal
        ref={confirmStartArqueacaoRef}
        disableBackdropClick
        disableEscapeKeyDown
        component={() => <p>{t('s.geral.acaonaopoderaserdesfeita')}</p>}
        title={t('s.operacao.arqueacaoautomatica.iniciar')}
        maxWidth="xs"
        loading={loadingStartArqueacao}
        actions={[
          {
            label: t('s.geral.iniciar'),
            autoFocus: true,
            disabled: loadingStartArqueacao,
            variant: 'outlined',
            color: 'primary',
            callback: (data) => handleStartArqueacao(),
          },
          {
            label: t('s.geral.botaovoltar'),
            disabled: loadingStartArqueacao,
            variant: 'outlined',
            color: 'secondary',
            callback: () => confirmStartArqueacaoRef.current.handleCloseModal(),
          },
        ]}
      />

      <Modal
        ref={confirmEndArqueacaoRef}
        disableBackdropClick
        disableEscapeKeyDown
        component={() => <p>{t('s.geral.acaonaopoderaserdesfeita')}</p>}
        title={t('s.operacao.arqueacaoautomatica.finalizar')}
        maxWidth="xs"
        loading={loadingEndArqueacao}
        actions={[
          {
            label: t('s.geral.finalizar'),
            autoFocus: true,
            disabled: loadingEndArqueacao,
            variant: 'outlined',
            color: 'primary',
            callback: (data) => handleEndArqueacao(),
          },
          {
            label: t('s.geral.botaovoltar'),
            variant: 'outlined',
            disabled: loadingEndArqueacao,
            color: 'secondary',
            callback: () => confirmEndArqueacaoRef.current.handleCloseModal(),
          },
        ]}
      />
    </S.Wrapper>
  );
}

export default ArqueacaoTanque;
